<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <!-- <router-view :key="key"></router-view> -->
      <router-view :key="$route.fullPath" />
    </transition>
  </section>
</template>

<script>
export default {
  name: "AppMain",
};
</script>

<style scoped lang="scss">
.app-main {
  height: 100%;
}
</style>